<template>
  <div class="about" ref="page">
    <section class="page-title-banner" :style="{ backgroundImage: `url('https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1920&q=80')` }">
      <div class="banner-overlay"></div>
      <div class="container">
        <span class="badge-light">COMPANY PROFILE</span>
        <h1 class="page-title">인류의 생활환경을 건강하고 <br/><span>쾌적하게 만드는 혁신 기업</span></h1>
      </div>
    </section>

    <!-- Management Philosophy -->
    <section class="philosophy-section animated-section">
      <div class="container">
        <SectionHeader badge="MANAGEMENT PHILOSOPHY" title="아스톡 경영철학" subtitle="신뢰와 혁신을 바탕으로 사람 중심의 공간 가치를 만듭니다." />

        <!-- Slogan Intro -->
        <div class="philosophy-intro">
          <span class="intro-en">{{ philosophy.slogan.en }}</span>
          <p class="intro-main">{{ philosophy.slogan.main }}</p>
        </div>

        <!-- CEO Message -->
        <div class="ceo-message">
          <div class="ceo-left">
            <span class="ceo-label">{{ philosophy.ceoMessage.label }}</span>
            <h3>{{ philosophy.ceoMessage.title }}</h3>
          </div>
          <div class="ceo-right">
            <p v-for="(para, i) in philosophy.ceoMessage.paragraphs" :key="i">{{ para }}</p>
            <div class="ceo-signature">{{ philosophy.ceoMessage.signature }}</div>
          </div>
        </div>

        <!-- Mission & Vision -->
        <div class="mv-grid">
          <div class="mv-card">
            <span class="mv-label">{{ philosophy.mission.label }}</span>
            <h3>{{ philosophy.mission.title }}</h3>
            <span class="mv-slogan">{{ philosophy.mission.slogan }}</span>
            <p>{{ philosophy.mission.desc }}</p>
          </div>
          <div class="mv-card">
            <span class="mv-label">{{ philosophy.vision.label }}</span>
            <h3>{{ philosophy.vision.title }}</h3>
            <span class="mv-slogan">{{ philosophy.vision.slogan }}</span>
            <p>{{ philosophy.vision.desc }}</p>
          </div>
        </div>

        <!-- Core Values -->
        <h3 class="core-values-title">핵심 가치 (Core Values)</h3>
        <div class="values-grid">
          <div class="value-card" v-for="value in philosophy.coreValues" :key="value.title">
            <span class="value-no">{{ value.no }}</span>
            <div class="value-icon">{{ value.icon }}</div>
            <h4>{{ value.title }}</h4>
            <p>{{ value.desc }}</p>
          </div>
        </div>

        <!-- Commitments -->
        <div class="commitments">
          <h3 class="core-values-title">아스톡의 약속</h3>
          <ul class="commitment-list">
            <li v-for="(item, i) in philosophy.commitments" :key="i">{{ item }}</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- Org Chart -->
    <section class="org-chart-bg animated-section">
      <div class="container">
        <SectionHeader badge="ORGANIZATION" title="본사 전문 조직 체계" subtitle="전문 엔지니어링 그룹과 법률/노무/세무 자문단이 유기적으로 협업합니다." />
        <div class="chart-box" style="margin-top: 5rem;">
          <div class="advisor-group">
            <div class="adv">노무자문위원</div>
            <div class="adv">법률자문위원</div>
            <div class="adv">세무자문위원</div>
            <div class="adv">회계자문위원</div>
          </div>
          <div class="chart-line"></div>
          <div class="ceo-node">대표이사</div>
          <div class="chart-line long"></div>
          <div class="dept-grid">
            <div class="dept red-line">
              <h4>사업관리본부 (PM)</h4>
              <ul><li>임대차 자산관리</li><li>회계 및 자금 보고</li><li>일반 행정 지원</li></ul>
            </div>
            <div class="dept red-line">
              <h4>기술컨설팅본부 (FM)</h4>
              <ul><li>시설물 정밀 안전진단</li><li>에너지 최적화 솔루션</li><li>재난 리스크 관리</li></ul>
            </div>
            <div class="dept red-line">
              <h4>위생/방역사업부</h4>
              <ul><li>호텔식 미화관리</li><li>아스톡 에어졸 솔루션</li><li>감염병 예방 소독</li></ul>
            </div>
            <div class="dept red-line">
              <h4>제조/구매사업부</h4>
              <ul><li>품질 관리 시스템</li><li>비용 절감 원가 분석</li><li>자재 생산 관리</li></ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Management Cycle -->
    <section class="cycle-section bg-light animated-section">
      <div class="container">
        <SectionHeader badge="MANAGEMENT PHILOSOPHY" title="관리사업의 변화 Cycle" subtitle="아스톡은 단순 시설 유지를 넘어 자산 가치 상승을 목표로 합니다." />
        <div class="cycle-container">
          <div class="cycle-item" v-for="item in managementCycle" :key="item.step">
            <div class="cycle-step">{{ item.step }}</div>
            <div class="cycle-content">
              <h4>{{ item.title }}</h4>
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- TSI Section -->
    <section class="tsi-section container animated-section">
      <SectionHeader badge="CUSTOMER SATISFACTION" title="TSI (Tenant Satisfaction Index)" subtitle="입주고객 만족도 조사를 통해 지속적으로 서비스를 개선합니다." />
      <div class="tsi-flow">
        <div class="tsi-step" v-for="item in tsiProcess" :key="item.name">
          <div class="tsi-icon">{{ item.icon }}</div>
          <h4>{{ item.name }}</h4>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SectionHeader from '../components/SectionHeader.vue';
import { managementPhilosophy, managementCycle, tsiProcess } from '../data/aboutData.js';

export default {
  name: 'AboutView',
  components: { SectionHeader },
  data() {
    return {
      philosophy: managementPhilosophy,
      managementCycle,
      tsiProcess
    }
  },
  mounted() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-up');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    this.$refs.page.querySelectorAll('.animated-section').forEach(section => {
      observer.observe(section);
    });
  }
}
</script>

<style scoped>
.banner-overlay {
  background: rgba(1, 58, 113, 0.8);
}
.page-title-banner .container { position: relative; z-index: 2; }
.badge-light { background: rgba(255,255,255,0.1); color: white; padding: 8px 15px; border-radius: 20px; font-size: 13px; font-weight: 700; }
.page-title { font-size: 52px; font-weight: 900; margin-top: 25px; line-height: 1.3; letter-spacing: -1.5px; }
.page-title span { color: var(--primary-red); }

/* Management Philosophy */
.philosophy-section { padding: 150px 0; background: white; }

/* Slogan Intro */
.philosophy-intro { text-align: center; max-width: 760px; margin: 4rem auto 0; }
.intro-en { display: inline-block; font-size: 14px; font-weight: 800; letter-spacing: 3px; color: var(--primary-red); margin-bottom: 20px; }
.intro-main { font-size: 28px; font-weight: 800; line-height: 1.5; color: var(--primary-blue); letter-spacing: -1px; }

/* CEO Message */
.ceo-message {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 50px;
  margin-top: 6rem;
  padding: 60px;
  background: #fbfcfe;
  border-radius: 20px;
  border-left: 6px solid var(--primary-blue);
}
.ceo-label { display: inline-block; font-size: 14px; font-weight: 900; letter-spacing: 2px; color: var(--primary-red); margin-bottom: 20px; }
.ceo-left h3 { font-size: 26px; line-height: 1.5; color: var(--primary-blue); }
.ceo-right p { font-size: 16px; line-height: 1.9; color: var(--text-sub); margin-bottom: 20px; }
.ceo-signature { margin-top: 30px; font-size: 17px; font-weight: 800; color: var(--primary-blue); text-align: right; }

/* Mission & Vision */
.mv-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 30px; margin-top: 6rem; }
.mv-card {
  padding: 50px 45px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.05);
  border-left: 6px solid var(--primary-red);
  transition: all 0.3s ease;
}
.mv-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(0,0,0,0.08);
}
.mv-label { display: inline-block; font-size: 14px; font-weight: 900; letter-spacing: 2px; color: var(--primary-red); margin-bottom: 15px; }
.mv-card h3 { font-size: 26px; color: var(--primary-blue); margin-bottom: 10px; }
.mv-slogan { display: block; font-size: 15px; font-weight: 700; font-style: italic; color: var(--primary-red); margin-bottom: 20px; }
.mv-card p { font-size: 16px; line-height: 1.8; color: var(--text-sub); }

.core-values-title { text-align: center; font-size: 28px; color: var(--primary-blue); margin: 6rem 0 3rem; }
.values-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 25px; }
.value-card {
  position: relative;
  padding: 45px 25px 40px;
  background: #fcfcfc;
  border: 1px solid #f0f0f0;
  border-top: 5px solid var(--primary-red);
  border-radius: 15px;
  text-align: center;
  transition: all 0.3s ease;
  overflow: hidden;
}
.value-card:hover {
  transform: translateY(-10px);
  background: white;
  box-shadow: 0 20px 50px rgba(0,0,0,0.07);
}
.value-no {
  position: absolute;
  top: 10px;
  right: 18px;
  font-size: 40px;
  font-weight: 900;
  color: #f2f4f8;
  line-height: 1;
}
.value-icon { font-size: 3rem; margin-bottom: 1.5rem; position: relative; }
.value-card h4 { font-size: 19px; color: var(--primary-blue); margin-bottom: 15px; }
.value-card p { font-size: 14px; line-height: 1.7; color: #777; text-align: left; }

/* Commitments */
.commitments { max-width: 900px; margin: 0 auto; }
.commitment-list { list-style: none; padding: 0; display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
.commitment-list li {
  position: relative;
  padding: 22px 25px 22px 55px;
  background: #fbfcfe;
  border-radius: 12px;
  font-size: 15px;
  line-height: 1.6;
  color: var(--text-sub);
  border: 1px solid #f0f0f0;
}
.commitment-list li::before {
  content: '✓';
  position: absolute;
  left: 22px;
  top: 22px;
  color: var(--primary-red);
  font-weight: 900;
  font-size: 18px;
}

.org-chart-bg { padding: 150px 0; background: white; }
.chart-box { text-align: center; }
.advisor-group { display: flex; justify-content: center; gap: 20px; margin-bottom: 40px; }
.adv { padding: 12px 25px; border: 2px dashed #ddd; border-radius: 8px; font-weight: 700; font-size: 15px; color: #777; background: #fcfcfc; transition: all 0.3s ease; }
.adv:hover { transform: translateY(-5px); border-color: var(--primary-red); color: var(--primary-blue); }
.ceo-node { display: inline-block; padding: 25px 90px; background: var(--primary-blue); color: white; font-size: 24px; font-weight: 900; border-radius: 8px; }
.chart-line { width: 2px; height: 50px; background: #eee; margin: 0 auto; }
.chart-line.long { height: 100px; }
.dept-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 25px; }
.dept {
  padding: 40px 25px;
  background: white;
  border: 1px solid #f0f0f0;
  border-top: 5px solid transparent; /* 호버 효과를 위한 공간 확보 */
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.03);
  text-align: center;
  transition: all 0.3s ease;
}
.dept:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(0,0,0,0.07);
  border-top-color: var(--primary-red); /* 호버 시 빨간색 라인 표시 */
}
.dept.red-line { border-top: 5px solid var(--primary-red); }
.dept h4 { font-size: 18px; color: var(--primary-blue); margin-bottom: 25px; }
.dept ul { list-style: none; padding: 0; }
.dept li { font-size: 15px; color: #777; margin-bottom: 10px; }
coreCompetencies
.cycle-section { padding: 150px 0; }
.cycle-container { display: flex; justify-content: center; gap: 20px; margin-top: 5rem; }
.cycle-item { position: relative; flex: 1; padding: 40px 30px; background: white; border-radius: 15px; box-shadow: 0 10px 40px rgba(0,0,0,0.05); text-align: center; transition: all 0.3s ease; border-bottom: 6px solid var(--primary-red); }
.cycle-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(0,0,0,0.08);
}
.cycle-item:not(:last-child)::after {
  content: '→';
  position: absolute;
  right: -25px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px;
  color: var(--primary-red);
  font-weight: bold;
}
.cycle-step { font-size: 14px; font-weight: 900; color: var(--primary-red); margin-bottom: 15px; }
.cycle-content h4 { font-size: 20px; color: var(--primary-blue); margin-bottom: 15px; }
.cycle-content p { color: var(--text-sub); font-size: 15px; }

.tsi-section { padding: 150px 0; }
.tsi-flow { display: flex; justify-content: center; align-items: center; gap: 30px; position: relative; }
.tsi-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;

  padding: 40px 25px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-top: 5px solid var(--primary-red); /* 상단 빨간 라인 */
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.03);

  transition: all 0.3s ease;
}
.tsi-step:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(0,0,0,0.08);
}
.tsi-icon {
  font-size: 3rem;
  margin-bottom: 1.5rem;
  color: var(--primary-blue);
}
@media (max-width: 1024px) {
  .page-title { font-size: 40px; }
  .intro-main { font-size: 22px; }
  .ceo-message { grid-template-columns: 1fr; gap: 25px; padding: 40px 30px; }
  .ceo-signature { text-align: left; }
  .mv-grid { grid-template-columns: 1fr; }
  .values-grid { grid-template-columns: 1fr 1fr; }
  .commitment-list { grid-template-columns: 1fr; }
  .dept-grid { grid-template-columns: 1fr 1fr; }
  .cycle-container { flex-direction: column; gap: 40px; }
  .advisor-group { flex-wrap: wrap; }
  .cycle-item:not(:last-child)::after { content: '↓'; right: 50%; top: auto; bottom: -30px; transform: translateX(50%); }
  .tsi-flow {
    flex-direction: column;
    gap: 40px;
  }
  .tsi-step:not(:last-child)::after {
    content: '↓';
    position: absolute;
    font-size: 3rem;
    color: var(--primary-red);
    opacity: 0.5;
    top: auto;
    bottom: -35px;
    transform: translateX(-50%);
  }
}
@media (max-width: 768px) {
  .dept-grid { grid-template-columns: 1fr; }
  .values-grid { grid-template-columns: 1fr; }
}
</style>